/**
 * Registration userschema actions.
 * @module actions/registrationUserschema
 */
export const GET_REGISTRATION_USERSCHEMA = 'GET_REGISTRATION_USERSCHEMA';

/**
 * Get registration userschema.
 * @function getRegistrationUserschema
 * @returns {Object} Get registration userschema action.
 */
export function getRegistrationUserschema() {
  return {
    type: GET_REGISTRATION_USERSCHEMA,
    request: {
      op: 'get',
      path: `/@register-userschema`,
    },
  };
}
